import { gql } from '@moonpig/web-core-graphql'

export const RemoveFromFavouritesListGQL = gql`
  mutation RemoveFromFavouritesList($productIds: [String!]!) {
    removeFromFavouritesList(productIds: $productIds) {
      products {
        id
        title
        slug
        dependencies
        category {
          slug
          name
          id
          department
        }
        customisable
        isLandscape
        rating {
          count
          score
        }
        masterVariant {
          key
          title
          productImages {
            mainImage {
              medium {
                jpgUrl
              }
            }
            images {
              small {
                jpgUrl
              }
              medium {
                jpgUrl
              }
              large {
                jpgUrl
              }
            }
          }
          price {
            centAmount
            currencyCode
            fractionDigits
          }
          fullPrice {
            centAmount
            currencyCode
            fractionDigits
          }
          discountedPercentage
          minimumQuantity
          inStock
          sku
        }
        variants {
          key
          title
          price {
            currencyCode
            centAmount
            fractionDigits
          }
          fullPrice {
            centAmount
            currencyCode
            fractionDigits
          }
          discountedPercentage
          inStock
          minimumQuantity
          sku
        }
        hasAugmentedReality
        isSponsored
        clickRankDocumentCount
      }
    }
  }
`
